const moduleName = "wms/businessRuleDistribution/";
export const id = {
    id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_DISTRIBUTION",
    name: "分配规则",
    type: "menu",
    apiName: "getDistributionList",
    url: `${moduleName}list`
};

export const children = {
    // GET_LIST: {
    //     id: 'WAREHOUSE_MANAGEMENT_BUSINESS_RULES_DISTRIBUTION_GET_LIST',
    //     apiName: 'getCarTypes',
    //     method: 'POST',
    //     name: '获取列表',
    //     type: 'view',
    //     url: `${moduleName}carType/getCarTypes`
    // },
    ADD_DATA: {
        id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_DISTRIBUTION_ADD_DATA",
        apiName: "addDistribution",
        method: "POST",
        name: "新建",
        type: "view",
        url: `${moduleName}save`
    },
    DEL_DATA: {
        id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_DISTRIBUTION_CODE",
        apiName: "delDistribution",
        method: "POST",
        name: "删除",
        type: "view",
        url: `${moduleName}delete`
    },
    EDIT_DATA: {
        id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_DISTRIBUTION_EDIT_DATA",
        apiName: "editDistribution",
        method: "POST",
        name: "编辑",
        type: "view",
        url: `${moduleName}save`
    },
    LOOK_MORE: {
        id: "WAREHOUSE_MANAGEMENT_BUSINESS_RULES_DISTRIBUTION_LOOK_MORE",
        name: "查看",
        type: "view"
    }
};
